<template>
  <span class="event-indicator" :style="{ '--calendar-event-type-color': mapIdToColor(id) }"></span>
</template>

<script>
  import { CALENDAR_LEGEND_COLORS } from '../../../constants/constants.js';

  export default {
    name: 'VesCalendarIndicator',

    props: {
      id: {
        type: [Number, String, null],
        default: null,
      },
    },

    methods: {
      mapIdToColor(id) {
        return CALENDAR_LEGEND_COLORS[id];
      },
    },
  };
</script>

<style lang="scss" scoped>
  .event-indicator {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: var(--calendar-event-type-color, #000);
  }
</style>
